// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * P20EE-209: what the unit is for the scheduling wizard. The values are the domain's `HOSPITAL_UNIT_TYPES`; a test
 * holds the two together. Null until the Operação sets it, and the wizard reads null as `collection`.
 */
export const hospitalUnitTypeSchema = z.enum([
    'collection',
    'sample_withdrawal',
])
export type HospitalUnitTypeContract = z.infer<typeof hospitalUnitTypeSchema>

/** One unit of `GET /api/business-units`. Strict, so a field that starts leaking into the list fails here. */
export const businessUnitRowSchema = z
    .object({
        Business_id: z.number().int(),
        Business_name: z.string(),
        codprocedencia: z.number().int(),
        hash: z.string(),
        unitType: hospitalUnitTypeSchema.nullable(),
    })
    .strict()
export type BusinessUnitRowContract = z.infer<typeof businessUnitRowSchema>

/** GET /api/business-units: the Operação gets every active unit; anyone else, their own. */
export const businessUnitsSchema = z
    .object({ rows: z.array(businessUnitRowSchema) })
    .strict()
export type BusinessUnitsContract = z.infer<typeof businessUnitsSchema>
